export default {
  DOWNLOAD_START: 'Downloading... please wait...',
  DOWNLOAD_SUCCESS: 'Thank you! You may now close this window.'
}
